import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "./supabaseClient";

const AuthRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange((_, session) => {
      if (session && location.pathname === "/login") {
        setTimeout(() => {
          navigate("/");
        }, 100); // 🔹 navigate 호출을 100ms 지연하여 해결
      }

      // ✅ 세션 없을 때 `/login`과 `/signup`만 예외 허용
      const isPublicPage = ["/login", "/signup", "/auth/callback"].includes(location.pathname);
      if (!session && !isPublicPage) {
        navigate("/login");
      }
    });

    return () => authListener.subscription.unsubscribe();
  }, [navigate, location]);

  return null;
};

export default AuthRedirect;
